// phonics_data_lt02.js
// Letter Teams L02 - L2 Long Vowel i - Magic e - CVCe
// 路由：/phonics/lt02

const MEDIA_BASE = '/media/phonics/lt02';
const V = 'v1';

export const letterDataLt02 = {
  id: 'lt02',
  letter: 'L02',
  title: 'L2 Long Vowel i - Magic e - CVCe',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P4-P6: 三段故事（story-video-left-lines-right）
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals are at the pine.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "They play a game.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Let's hide.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "One, two, three...", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "... nine, ten!", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Red looks for the pals.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Where did they hide?", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Did Blue hide at the hive?", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "No, Yellow is at the hive.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Did Green hide on the bike?", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "No, Blue is on the bike.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Did Pink hide in the vine?", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "No, Green is in the vine.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Pink, where are you?", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Look up!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Pink is on the kite!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
      ],
    },
  ],
};
